<template>
  <default-layout :unstick-header="unstickHeader" class="card-canvas">
    <slot name="header" />
    <main-container :size="size">
      <el-card class="card-canvas__card">
        <remote-control-button
          v-if="!hideBackButton"
          class="page-back-button"
          icon-name="arrow-left"
          tooltip-text="Back"
          @click="$router.go(-1)"
        />
        <slot />
      </el-card>
    </main-container>
  </default-layout>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import MainContainer from '@/layouts/main-container.vue'
import DefaultLayout from '@/layouts/default-layout.vue'

export default defineComponent({
  name: 'CardCanvas',

  components: {
    DefaultLayout,
    MainContainer,
  },

  props: {
    /* See main container */
    size: {
      type: String,
      default: 'medium',
    },
    hideBackButton: {
      type: Boolean,
      default: false,
    },
    unstickHeader: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss">
.card-canvas {
  &__card {
    position: relative;
    overflow: visible;
    padding: 10px 20px 20px 20px;

    @include media-breakpoint-down(sm) {
      &.el-card {
        border-radius: 0 !important;
      }
    }

    .page-back-button {
      position: absolute;
      top: -17px;
      left: 16px;

      @include media-breakpoint-up(md) {
        top: 9px;
        left: -19px;
      }

      /* Between lg and 1040px, back button needs to be tighter so it flows in the screen */
      @include media-breakpoint-up(lg) {
        left: -26px;
      }

      @include media-breakpoint-up(xl) {
        left: -43px;
      }
    }
  }
}
</style>
